import { FunctionComponent, useEffect, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
// import { useNavigate } from 'react-router-dom';
// import { useTranslation } from 'react-i18next'

import { fetch_all } from '../../lib/server_helper';

import {
  StyledSelect
} from '../../components/interface';

import { Project } from '../../models/Project';
import { loginAtom } from '../../lib/auth';

type Props = {
  value: string;
  onChange: (x:string) => void;
  hasCreateNew?: boolean;
  overrideLabel?: string;
};

export const PickersProjectPicker: FunctionComponent<Props> = ({value, onChange, hasCreateNew, overrideLabel}) => {
  // const theme = useTheme();
  // const navigate = useNavigate();
  // const {t, i18n} = useTranslation(['translations']);

  const [login, setLogin] = useAtom(loginAtom);

  const [projects, setProjects] = useState<Project[]>([]);
  const [loader, setLoader] = useState<boolean>(true);
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("name ASC");

  useEffect(() => {
    onSearch('');
  }, [page, order]);

  const onSearch = (s: string) => {
    // console.log(filters);
    setLoader(true);
    fetch_all<Project>('/nl/v3/objects/fetch_all', {
      object: 'project',
      fields: ['id', 'name'],
      per_page: 1000,
      page: page,
      order: order
    }, (obs, complete_data) => {
      setProjects(obs);
      setLoader(false);
    }, (z) => {
      
    }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
  };

  return (<>
    <StyledSelect
      label={!!overrideLabel ? overrideLabel : "Projects"}
      value={value}
      id='projects'
      onChange={(v) => {
        onChange(v);
      }}
      list={([...(!!hasCreateNew ? [{id: 0, name : '--- Maak nieuw aan ---'}] : []), ...projects]).map(project => ({id: (project.id || 0).toString(), name: (project.name || '')}))}
    />
  </>);
}




